module.exports = __webpack_public_path__ + "img/ellipse-01.8545ac5b.png";